export const PHOTO_PRODUCT_TYPE_CODE = {
    all: 3, // 전체 -- 실제 photo prodcut의 타입값으로 사용되는것은 아니고, 필터에서 "전체"를 처리할때 사용되는 값이다.(즉 실제 photo product의 타입값은 1, 2 뿐이다.)
    normal: 2, // 일반
    contract: 1, // 계약
    none: 0, // 없음 --  실제 photo prodcut의 타입값으로 사용되는것은 아니고, 초기에 아무것도 선택하지 않음을 처리할때 사용되는 값이다.
} as const;

